import _isEmpty from "lodash/isEmpty";
import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import classes from '@nerdwallet/base-styles/classes';
import { Button, Link, Type } from '@nerdwallet/currency';
import styles from './marketplace-product-card.module.less';
export var REG_FLOW = 'credit-score';
/**
 * Open the nw-auth-dialog with parameterized tracking meta data.
 * @param {object} trk - Any trk params to be sent accompanying tracking & registration events
 */

export var handleAuthClickDefault = function handleAuthClickDefault(trk) {
  var _global, _global$nwapi, _global$nwapi$ui, _global$nwapi$ui$show;

  return (_global = global) === null || _global === void 0 ? void 0 : (_global$nwapi = _global.nwapi) === null || _global$nwapi === void 0 ? void 0 : (_global$nwapi$ui = _global$nwapi.ui) === null || _global$nwapi$ui === void 0 ? void 0 : (_global$nwapi$ui$show = _global$nwapi$ui.showAuthDialog) === null || _global$nwapi$ui$show === void 0 ? void 0 : _global$nwapi$ui$show.call(_global$nwapi$ui, {
    version: 2,
    trk: trk,
    flow: REG_FLOW,
    onSuccess: function onSuccess() {
      var _global$window, _global$window$locati, _global$window$locati2;

      return (_global$window = global.window) === null || _global$window === void 0 ? void 0 : (_global$window$locati = _global$window.location) === null || _global$window$locati === void 0 ? void 0 : (_global$window$locati2 = _global$window$locati.reload) === null || _global$window$locati2 === void 0 ? void 0 : _global$window$locati2.call(_global$window$locati, true);
    }
  });
};

var LoaCtaContent = function LoaCtaContent(_ref) {
  var analytics = _ref.analytics,
      ctaText = _ref.ctaText,
      enableAnalytics = _ref.enableAnalytics,
      isKetoCard = _ref.isKetoCard,
      onClick = _ref.onClick;
  var impressionContext = useContext(ImpressionContext);
  var internalOnclick = useCallback(function () {
    if ((analytics === null || analytics === void 0 ? void 0 : analytics.enabled) || enableAnalytics || !_isEmpty(analytics)) {
      onClick(impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId);
    } else {
      onClick();
    }
  }, [analytics, enableAnalytics, impressionContext, onClick]);

  if (isKetoCard) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
      onClick: internalOnclick
    }, /*#__PURE__*/React.createElement(Type, {
      size: "1"
    }, ctaText)));
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles['loaCta--wide']
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: internalOnclick
  }, /*#__PURE__*/React.createElement(Type, {
    size: "1"
  }, ctaText))), /*#__PURE__*/React.createElement("div", {
    className: styles['loaCta--mobile']
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes(['background-white', 'width-100']),
    onClick: internalOnclick
  }, ctaText)));
};

LoaCtaContent.propTypes = {
  analytics: PropTypes.shape({
    entityName: PropTypes.string,
    enabled: PropTypes.bool
  }),
  ctaText: PropTypes.string.isRequired,
  enableAnalytics: PropTypes.bool,
  onClick: PropTypes.func,
  isKetoCard: PropTypes.bool
};

var LikelihoodOfApprovalCTA = function LikelihoodOfApprovalCTA(_ref2) {
  var analytics = _ref2.analytics,
      ctaText = _ref2.ctaText,
      enableAnalytics = _ref2.enableAnalytics,
      onClick = _ref2.onClick,
      isKetoCard = _ref2.isKetoCard;
  return /*#__PURE__*/React.createElement(Impression, {
    eventType: "registration_cta_impression",
    entityName: (analytics === null || analytics === void 0 ? void 0 : analytics.entityName) || 'product_card_approval_cta',
    enabled: (analytics === null || analytics === void 0 ? void 0 : analytics.enabled) || enableAnalytics || !_isEmpty(analytics),
    payload: {
      additional_attributes: {
        target_flow: REG_FLOW,
        cta_mode: 'modal',
        cta_format: 'link',
        cta_label: ctaText
      },
      element_position: analytics === null || analytics === void 0 ? void 0 : analytics.elementPosition,
      section_name: (analytics === null || analytics === void 0 ? void 0 : analytics.sectionName) || 'likelihood_approval',
      section_position: analytics === null || analytics === void 0 ? void 0 : analytics.sectionPosition
    }
  }, /*#__PURE__*/React.createElement(LoaCtaContent, {
    analytics: analytics,
    ctaText: ctaText,
    enableAnalytics: enableAnalytics,
    isKetoCard: isKetoCard,
    onClick: onClick
  }));
};

LikelihoodOfApprovalCTA.propTypes = {
  analytics: PropTypes.shape({
    elementPosition: PropTypes.number,
    enabled: PropTypes.bool,
    entityName: PropTypes.string,
    sectionName: PropTypes.string,
    sectionPosition: PropTypes.number
  }),
  ctaText: PropTypes.string.isRequired,
  enableAnalytics: PropTypes.bool,
  onClick: PropTypes.func,
  isKetoCard: PropTypes.bool
};
LikelihoodOfApprovalCTA.defaultProps = {
  analytics: {
    elementPosition: 0,
    sectionPosition: 0
  },
  onClick: function onClick(impressionId) {
    return handleAuthClickDefault({
      navigation_source_impression_id: impressionId
    });
  },
  isKetoCard: false
};
export default LikelihoodOfApprovalCTA;